import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../APIRoute";
import { apiCall, apiCallAdvanced } from "../../AxiosService";
import { apiResponse } from "../../APIResponse";

export const CaseSave = createAsyncThunk(
  "CaseSave",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.CASE_SAVE,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) {}
  }
);

export const CaseDelete = createAsyncThunk(
  "CaseDelete",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "DELETE",
          url: API_URL.BASEURL + API_URL.CASE.CASE_DELETE,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const CaseGetByPrimaryKey = createAsyncThunk(
  "CaseGetByPrimaryKey",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.CASE_GET_BY_PRIMARY_KEY,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const CaseGetList = createAsyncThunk(
  "CaseGetList",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.CASE_GET_LIST,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const CaseGetByDetail = createAsyncThunk(
  "CaseGetByDetail",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.CASE_GET_BY_DETAIL,
          body: data,
        },
        true
      );
      let response = apiResponse(false, resData);

      return response;
    } catch (error) {}
  }
);

export const CaseUpdateStatus = createAsyncThunk(
  "CaseUpdateStatus",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.CASE_UPDATE_STATUS,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) {}
  }
);

export const CaseUpdateAssign = createAsyncThunk(
  "CaseUpdateAssign",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.CASE_UPDATE_ASSIGN,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) {}
  }
);

export const SaveActivity = createAsyncThunk(
  "SaveActivity",
  async (data, { dispatch }) => {
    try {
      let resData = await apiCallAdvanced(
        {
          method: "POST",
          url: API_URL.BASEURL + API_URL.CASE.SAVE_ACTIVITY,
          body: data,
        },
        true
      );
      let response = apiResponse(true, resData);

      return response;
    } catch (error) {}
  }
);

const initialState = {
  CaseSaveData: {
    data: null,
    error: null,
  },
  CaseDeleteData: {
    data: null,
    error: null,
  },

  CaseGetByPrimaryKeyData: {
    data: null,
    error: null,
  },
  CaseGetListData: {
    data: null,
    error: null,
  },
  CaseGetByDetailData: {
    data: null,
    error: null,
  },
  CaseUpdateStatusData: {
    data: null,
    error: null,
  },
  CaseUpdateAssignData: {
    data: null,
    error: null,
  },
  SaveActivityData: {
    data: null,
    error: null,
  },
};

const CaseSlice = createSlice({
  name: "CASESLICE",
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder
      .addCase(CaseSave.fulfilled, (state, action) => {
        state.CaseSaveData.data = action.payload;
      })
      .addCase(CaseSave.rejected, (state, action) => {
        state.CaseSaveData.error = action.error.message;
      })
      .addCase(CaseDelete.fulfilled, (state, action) => {
        state.CaseDeleteData.data = action.payload;
      })
      .addCase(CaseDelete.rejected, (state, action) => {
        state.CaseDeleteData.error = action.error.message;
      })
      .addCase(CaseGetByPrimaryKey.fulfilled, (state, action) => {
        state.CaseGetByPrimaryKeyData.data = action.payload;
      })
      .addCase(CaseGetByPrimaryKey.rejected, (state, action) => {
        state.CaseGetByPrimaryKeyData.error = action.error.message;
      })
      .addCase(CaseGetList.fulfilled, (state, action) => {
        state.CaseGetListData.data = action.payload;
      })
      .addCase(CaseGetList.rejected, (state, action) => {
        state.CaseGetListData.error = action.error.message;
      })
      .addCase(CaseGetByDetail.fulfilled, (state, action) => {
        state.CaseGetByDetailData.data = action.payload;
      })
      .addCase(CaseGetByDetail.rejected, (state, action) => {
        state.CaseGetByDetailData.error = action.error.message;
      })
      .addCase(CaseUpdateStatus.fulfilled, (state, action) => {
        state.CaseUpdateStatusData.data = action.payload;
      })
      .addCase(CaseUpdateStatus.rejected, (state, action) => {
        state.CaseUpdateStatusData.error = action.error.message;
      })
      .addCase(CaseUpdateAssign.fulfilled, (state, action) => {
        state.CaseUpdateAssignData.data = action.payload;
      })
      .addCase(CaseUpdateAssign.rejected, (state, action) => {
        state.CaseUpdateAssignData.error = action.error.message;
      })
      .addCase(SaveActivity.fulfilled, (state, action) => {
        state.SaveActivityData.data = action.payload;
      })
      .addCase(SaveActivity.rejected, (state, action) => {
        state.SaveActivityData.error = action.error.message;
      });
  },
});

export default CaseSlice.reducer;
